import { OverquotaUseApiStatus } from 'reactApp/appHelpers/featuresHelpers/features/overquotaUseApiStatus';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

export const isCloudOrMailOrApiOverQuota = createSelector(
    [
        (state: RootState) => UserSelectors.isOverQuotaUser(state), // только Облачная оверквота на основе инфы о квоте из SSR
        (state: RootState) => UserQuotaSelectors.isOverquota(state), // оверквота по Почте + Облаку по ручке UserQuotaSelectors.isOverquota (т.е. по ответу user/quota)
        (state: RootState) => UserQuotaSelectors.isOverquotaBySpaceAndApi(state), // апишная оверквота с даблчеком по UserQuotaSelectors.isOverquota
    ],
    (isOverQuotaCloud, isOverQuotaMailAndCloud, isOverquotaBySpaceAndApi) =>
        isOverQuotaCloud || isOverQuotaMailAndCloud || isOverquotaBySpaceAndApi
);

export const isOverquotaWithStatus = createSelector(
    UserQuotaSelectors.isOverquota,
    UserQuotaSelectors.isOverquotaBySpaceAndApi,
    (isOverquotaBySpace, isOverquotaBySpaceAndApi) => {
        return OverquotaUseApiStatus ? isOverquotaBySpaceAndApi : isOverquotaBySpace;
    }
);
